import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorService {
  readonly errorStatus = signal<number | null>(null);

  handleGlobalErrorStatus(status: number): void {
    this.errorStatus.set(status);
  }
  clearError(): void {
    this.errorStatus.set(null);
  }
}
